import { useLayoutEffect, useState } from "react";

export const useSyncExternalStore = (subscribe, getData) => {
	const [data, setData] = useState(getData);

	useLayoutEffect(() => {
		const onUpdate = () => {
			setData(getData);
		};

		const unsubscribe = subscribe(onUpdate);

		return () => {
			unsubscribe();
		};
	}, [getData, subscribe]);

	return data;
};
